var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEckodexGameLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.544,
    height: 27.025,
    viewBox: "0 0 167.544 27.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.203,
    y1: -0.134,
    x2: 0.613,
    y2: 0.678,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eckodex_game_loading",
    transform: "translate(-0.777 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143814",
    "data-name": "Path 143814",
    d: "M18.982,0h2.59V5.205H5.982V10.41h13V13H16.367v2.615H5.982v5.18h15.59V26H.777V0H18.982ZM43.357,2.615h2.59V7.82H40.742V5.205H30.357v15.59H40.742v-2.59h5.205V23.41h-2.59V26H27.768V23.41H25.152V2.615h2.615V0h15.59Zm16.555,7.82v5.18h2.615V18.23h2.59v2.59h2.59v2.615h2.615v2.59h-7.8v-2.59H59.912V20.82h-2.59V18.23h-2.59v7.795H49.527v-26h5.205V7.82h2.59V5.23h2.59V2.641h2.615V.025h7.8V2.641H67.707V5.23h-2.59V7.82h-2.59v2.615Zm32.2-7.795H94.7V23.435h-2.59v2.59H76.518v-2.59H73.9V2.641h2.615V.025h15.59Zm-2.59,5.18V5.23H79.107V20.82h10.41v-13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143815",
    "data-name": "Path 143815",
    d: "M116.482,5.205h2.59v15.59h-2.59V23.41h-2.615V26H98.277V0h15.59V2.615h2.615ZM113.867,7.82V5.205H103.482v15.59h10.385V7.82ZM140.857,0h2.59V5.205h-15.59V10.41h13V13h-2.615v2.615H127.857v5.18h15.59V26h-20.8V0h18.2Zm24.375.025h2.59V7.82h-2.59v2.615h-2.589v2.59h-2.616v2.59h2.616V18.23h2.589v2.59h2.59v5.205h-5.179v-2.59h-2.616V20.82h-5.2v2.615h-2.59v2.59h-5.205V20.82h2.616V18.23h2.589V15.615h2.59v-2.59h-2.59v-2.59h-2.589V7.82h-2.616V.025h5.205V5.23h2.59V7.82h5.2V5.23h2.616V.025Z",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckodexGameLoading);
export default __webpack_public_path__ + "static/media/eckodex_game_loading.824e1dd0aac6d87fc82710c6accd805f.svg";
export { ForwardRef as ReactComponent };